import VueRouter from 'vue-router'

/*创建一个路由*/
export default new VueRouter({
    routes:[
        {
            path:'/',
            component:()=>import ('@/pages/mainMenu/MainMenu.vue') 
        },
        {
            path:'/home',
            component:()=>import ('@/pages/mainMenu/MainMenu.vue') 
        },
        {
            path:'/readcardMenu',
            component:()=>import ('@/pages/readCard/ReadCardMenu.vue') 
        },
        {
            path:'/ReadShenFenzheng',
            component:()=>import ('@/pages/readCard/ReadShenFenzheng.vue') 
        }
        ,
        {
            path:'/ReadHandInput',
            component:()=>import ('@/pages/readCard/ReadHandInput.vue') 
        }
        ,
        {
            path:'/ReadQRCode',
            component:()=>import ('@/pages/readCard/ReadQRCode.vue') 
        }
        ,
        {
            path:'/ReadHospCard',
            component:()=>import ('@/pages/readCard/ReadHospCard.vue') 
        }
        ,
		{
		    path:'/ReadSiCard',
		    component:()=>import ('@/pages/readCard/ReadSiCard.vue') 
		},
        {
		    path:'/ReadSiEcCard',
		    component:()=>import ('@/pages/readCard/ReadSiEcCard.vue') 
		},
		
        {
            path:'/ClinicDeptList',
            component:()=>import ('@/pages/regist/ClinicDeptList.vue') 
        }
        ,
        {
            path:'/ClinicDoctorList',
            component:()=>import ('@/pages/regist/ClinicDoctorList.vue') 
        }
        ,
        {
            path:'/RegistPay',
            component:()=>import ('@/pages/regist/RegistPay.vue') 
        } ,
        {
            path:'/PayResult',
            component:()=>import ('@/pages/payments/PayResult.vue') 
        },
        {
            path:'/RegistResult',
            component:()=>import ('@/pages/regist/RegistResult.vue') 
        },
        {
            path:'/PaymentList',
            component:()=>import ('@/pages/payments/PaymentList.vue') 
        },
        {
            path:'/HesuanPay',
            component:()=>import ('@/pages/hesuan/HesuanPay.vue') 
        },
        {
            path:'/InpPayment',
            component:()=>import ('@/pages/inpPayment/InpPayment.vue') 
        },
        {
            path:'/InpPrePayResult',
            component:()=>import ('@/pages/inpPayment/InpPrePayResult.vue') 
        },
        {
            path:'/PatIdPrint',
            component:()=>import ('@/pages/print/patIdPrint/PatIdPrint.vue') 
        },
        {
            path:'/VoucherPrint',
            component:()=>import ('@/pages/print/voucherPrint/VoucherPrint.vue') 
        },
        {
            path:'/ReportPrint',
            component:()=>import ('@/pages/print/reportPrint/ReportPrint.vue') 
        },
        {
            path:'/InvoicePrint',
            component:()=>import ('@/pages/print/invoicePrint/InvoicePrint.vue') 
        },
        {
            path:'/BillingPrint',
            component:()=>import ('@/pages/print/billingPrint/BillingPrint.vue') 
        },
        {
            path:'/EMRPrint',
            component:()=>import ('@/pages/print/emrPrint/EMRPrint.vue') 
        },
        {
            path:'/CreateCard',
            component:()=>import ('@/pages/healthCard/createCard.vue') 
        },
        {
            path:"/readCreadCardMenu",
            component:()=>import ('@/pages/healthCard/readCreadCardMenu.vue') 
        },
        {
            path:"/Appointment",
            component:()=>import ('@/pages/regist/appointment.vue') 
        },
        {
            path:"/readMediCardMenu",
            component:()=>import ('@/pages/mediCard/readMediCardMenu.vue') 
        },
        {
            path:"/PatMediCard",
            component:()=>import ('@/pages/mediCard/PatMediCard.vue') 
        },
        {
            path:"/priceInquiryMenu",
            component:()=>import ('@/pages/inquire/priceInquiry.vue') 
        },
        {
            path:'/VoucherPrintGh',
            component:()=>import ('@/pages/print/voucherPrint/VoucherPrintGh.vue') 
        }
        
        
    ]
})

